import { useState, useEffect, useCallback } from 'react';
import { FacilityGroupsApi } from '@/api/clients/facility-groups/facility-groups.api';

export const useGetFacilityGroupTree = (organizationId, options = {}) => {
  const { enabled = true } = options;

  const [treeData, setTreeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTreeData = useCallback(async () => {
    if (!organizationId) {
      setLoading(false);
      return [];
    }

    setLoading(true);
    setError(null);
    try {
      const response = await FacilityGroupsApi.getFacilityGroupTree(
        organizationId,
      );
      const data = response.data?.data || [];
      setTreeData(data);
      return data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'Failed to fetch facility group tree';
      setError(errorMessage);
      console.error('Error fetching facility groups tree:', err);
      return [];
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    if (enabled) {
      fetchTreeData();
    }
  }, [fetchTreeData, enabled]);

  return {
    treeData,
    loading,
    error,
    refetch: fetchTreeData,
  };
};
